export default __webpack_public_path__ + "static/media/vdai.4f454e9e.png";